<template>
  <v-data-table
    :items="items"
    :headers="headers"
    :loading="loading"
    :items-per-page="-1"
    sort-by="id"
    sort-desc
  >
    <template v-slot:item.person="{ item }">
      <PersonItem small :value="item.person" />
    </template>
    <template v-slot:item.person.eventoId="{ item }">
      {{ item.person.eventoId }}<CopyButton :value="item.person.eventoId" />
    </template>

    <template v-slot:item.creationTimestamp="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <DateValue :value="item.creationDate" /><br />
            <span class="text--secondary"
              ><TimeValue :value="item.creationTime"
            /></span>
          </div>
        </template>
        <div><PersonItemBasic small :value="item.creator" dark /></div>
      </v-tooltip>
    </template>

    <template v-slot:item.newValue="{ item }">
      <span>{{ item.newValue }}</span>
      <CopyButton :value="item.newValue" />
    </template>

    <template v-slot:item.evaluationTimestamp="{ item }">
      <div v-if="item.evaluator">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <DateValue :value="item.evaluationDate" /><br />
              <span class="text--secondary"
                ><TimeValue :value="item.evaluationTime"
              /></span>
            </div>
          </template>
          <div><PersonItemBasic small :value="item.evaluator" dark /></div>
        </v-tooltip>
      </div>
      <v-tooltip top v-else>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <v-btn icon @click="evaluate(item.id)"
              ><v-icon>mdi-square-outline</v-icon></v-btn
            >
          </div>
        </template>
        <span>Bearbeitung des Änderungswunsches durch Klick bestätigen</span>
      </v-tooltip>
    </template>
  </v-data-table>
</template>

<script>
import { defineComponent } from "vue";
import { comparePeople } from "common/utils/people.js";
import CopyButton from "@/components/CopyButton";
import DateValue from "common/components/DateValue.vue";
import PersonItem from "common/components/PersonItem.vue";
import PersonChip from "common/components/PersonChip.vue";
import PersonItemBasic from "common/components/PersonItemBasic.vue";
import TimeValue from "common/components/TimeValue.vue";
export default defineComponent({
  components: {
    CopyButton,
    DateValue,
    PersonItem,
    PersonChip,
    PersonItemBasic,
    TimeValue,
  },
  props: ["items", "loading"],
  data() {
    return {
      saving: false,
      filter: {
        showAll: false,
      },
      headers: [
        {
          text: "Betrifft",
          value: "person",
          sort: comparePeople,
        },
        {
          text: "Evento ID",
          value: "person.eventoId",
        },
        {
          text: "erstellt",
          value: "creationTimestamp",
        },
        {
          text: "Beschreibung",
          value: "description",
        },
        {
          text: "alter Wert",
          value: "oldValue",
          cellClass: "text-decoration-line-through red--text text--darken-2",
        },
        {
          text: "neuer Wert",
          value: "newValue",
          cellClass: "green--text text--darken-2",
        },
        {
          text: "bearbeitet am",
          value: "evaluationTimestamp",
          align: "right",
        },
      ],
    };
  },
  methods: {
    async evaluate(id) {
      await this.apiPatch({
        resource: "checkin/person/",
        id: id,
        key: "evaluate",
        value: true,
      });
      this.$emit("updated");
    },
  },
});
</script>
